import { useEffect, useState } from "react";
import {
  getImpactStories,
  createImpactStory,
  updateImpactStory,
  deleteImpactStory,
} from "../../../api/apiServices";

export default function StoriesSection() {
  const [stories, setStories] = useState([]);
  const [editingStory, setEditingStory] = useState(null);
  const [isAdding, setIsAdding] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const [blocks, setBlocks] = useState([]);

  const emptyStory = {
    title: "",
    category: "Recovery Story",
    excerpt: "",
    fullStory: "",
    isPublished: true,
  };

  /* ---------------- LOAD ---------------- */
  useEffect(() => {
    fetchStories();
  }, []);

  const fetchStories = async () => {
    try {
      setLoading(true);
      const res = await getImpactStories();
      setStories(res.data || []);
    } catch (err) {
      console.error("Failed to load stories", err);
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- SAVE ---------------- */
//   const handleSave = async () => {
//   try {
//     const formData = new FormData();

//     formData.append("title", editingStory.title);
//     formData.append("category", editingStory.category);
//     formData.append("excerpt", editingStory.excerpt);
//     formData.append("isPublished", editingStory.isPublished);

//     const paragraphs = [];
//     const existingImages = [];

//     blocks.forEach(block => {
//       if (block.type === "paragraph") {
//         paragraphs.push(block.text);
//       }
//       if (block.type === "image" && block.file) {
//         formData.append("images", block.file);
//       }

//       if (block.type === "image" && block.existing) {
//         existingImages.push(block.preview);
//       }
//     });

//     formData.append("paragraphs", JSON.stringify(paragraphs));
//     formData.append("existingImages", JSON.stringify(existingImages));

//     if (isAdding) {
//       await createImpactStory(formData);
//     } else {
//       await updateImpactStory(editingStory._id, formData);
//     }

//     await fetchStories();

//     setEditingStory(null);
//     setBlocks([]);
//     setIsAdding(false);

//     setShowSuccess(true);
//     setTimeout(() => setShowSuccess(false), 3000);
//   } catch (err) {
//     console.error("Save failed", err);
//   }
// };

const handleSave = async () => {
  try {
    const formData = new FormData();

    formData.append("title", editingStory.title);
    formData.append("category", editingStory.category);
    formData.append("excerpt", editingStory.excerpt);
    formData.append("isPublished", editingStory.isPublished);

    const structuredContent = [];

    blocks.forEach((block, index) => {

      // TEXT BLOCK
      if (block.type === "paragraph") {
        structuredContent.push({
          type: "paragraph",
          text: block.text
        });
      }

      // OLD IMAGE
      if (block.type === "image" && block.existing) {
        structuredContent.push({
          type: "image",
          image: block.preview,
          existing: true
        });
      }

      // NEW IMAGE
      if (block.type === "image" && block.file) {
        const key = `image_${index}`;
        formData.append(key, block.file);

        structuredContent.push({
          type: "image",
          uploadKey: key,
          existing: false
        });
      }
    });

    formData.append("content", JSON.stringify(structuredContent));

    if (isAdding) {
      await createImpactStory(formData);
    } else {
      await updateImpactStory(editingStory._id, formData);
    }

    await fetchStories();

    setEditingStory(null);
    setBlocks([]);
    setIsAdding(false);

  } catch (err) {
    console.error(err);
  }
};



  /* ---------------- DELETE ---------------- */
  const handleDelete = async (id) => {
    if (!confirm("Are you sure you want to delete this story?")) return;
    await deleteImpactStory(id);
    setStories(stories.filter((s) => s._id !== id));
  };

  /* ---------------- TOGGLE PUBLISH ---------------- */
  const togglePublish = async (story) => {
    try {
      const formData = new FormData();
      formData.append("isPublished", !story.isPublished);
      await updateImpactStory(story._id, formData);
      setStories(
        stories.map((s) =>
          s._id === story._id
            ? { ...s, isPublished: !s.isPublished }
            : s
        )
      );
    } catch (err) {
      console.error("Publish toggle failed", err);
    }
  };

  const addParagraph = () => {
  setBlocks([
    ...blocks,
    { id: Date.now(), type: "paragraph", text: "" },
  ]);
};

const addImage = (file) => {
  setBlocks([
    ...blocks,
    {
      id: Date.now(),
      type: "image",
      file,
      preview: URL.createObjectURL(file),
    },
  ]);
};

const updateBlockText = (id, value) => {
  setBlocks(blocks.map(b => b.id === id ? { ...b, text: value } : b));
};

const removeBlock = (id) => {
  setBlocks(blocks.filter(b => b.id !== id));
};

const moveBlock = (index, direction) => {
  const newBlocks = [...blocks];
  const target = index + direction;
  if (target < 0 || target >= blocks.length) return;
  [newBlocks[index], newBlocks[target]] = [newBlocks[target], newBlocks[index]];
  setBlocks(newBlocks);
};

const getStoryThumbnail = (story) => {
  if (!story?.content) return null;

  const imgBlock = story.content.find(block => block.type === "image");
  return imgBlock?.image || null;
};

const convertStoryToBlocks = (story) => {
  if (!story?.content) return [];

  return story.content.map((item, index) => {
    if (item.type === "paragraph") {
      return {
        id: item._id || `p-${index}`,
        type: "paragraph",
        text: item.text || ""
      };
    }

    if (item.type === "image") {
      return {
        id: item._id || `i-${index}`,
        type: "image",
        preview: item.image, // existing image url
        existing: true
      };
    }

    return null;
  }).filter(Boolean);
};

  return (
    <div className="space-y-6">
      {/* HEADER */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold">Impact Stories</h2>
          <p className="text-sm text-gray-600">
            Manage survivor stories and testimonials
          </p>
        </div>

        <button
          onClick={() => {
            setEditingStory(emptyStory);
            setIsAdding(true);
            setImagePreview("");
            setImageFile(null);
          }}
          className="bg-[#6a4bc3] text-white px-6 py-2.5 rounded-lg flex items-center gap-2"
        >
          <i className="ri-add-line" /> Add Story
        </button>
      </div>

      {showSuccess && (
        <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-lg text-sm">
          Story saved successfully
        </div>
      )}

      {/* LIST */}
      {!editingStory && (
        <div className="bg-white rounded-xl border">
          {loading ? (
            <p className="p-6 text-sm text-gray-500">Loading…</p>
          ) : (
             <table className="w-full">
              <thead className="bg-gray-50 border-b">
                <tr>
                  <th className="text-left px-6 py-4 text-sm font-semibold">
                    Story
                  </th>
                  <th className="text-left px-6 py-4 text-sm font-semibold">
                    Category
                  </th>
                  <th className="text-left px-6 py-4 text-sm font-semibold">
                    Status
                  </th>
                  <th className="text-right px-6 py-4 text-sm font-semibold">
                    Actions
                  </th>
                </tr>
              </thead>

              <tbody className="divide-y">
                {stories.map((story) => (
                  <tr key={story._id}>
                    <td className="px-6 py-4">
                      <div className="flex gap-4">
                        {getStoryThumbnail(story) ? (
  <img
    src={getStoryThumbnail(story)}
    className="w-16 h-16 rounded-lg object-cover"
    alt="story"
  />
) : (
  <div className="w-16 h-16 rounded-lg bg-gray-200 flex items-center justify-center text-xs text-gray-500">
    No Image
  </div>
)}
                        <div>
                          <p className="font-medium text-sm">
                            {story.title}
                          </p>
                          <p className="text-xs text-gray-500 line-clamp-2">
  {story.excerpt ||
    story.content?.find(c => c.type === "paragraph")?.text?.slice(0, 120) ||
    "No preview available"}
</p>
                        </div>
                      </div>
                    </td>

                    <td className="px-6 py-4">
                      <span className="text-xs bg-[#c9a24d]/10 text-[#c9a24d] px-3 py-1 rounded-full">
                        {story.category}
                      </span>
                    </td>

                    <td className="px-6 py-4">
                      <button
                        onClick={() => togglePublish(story)}
                        className={`px-3 py-1 rounded-full text-xs ${
                          story.isPublished
                            ? "bg-green-100 text-green-700"
                            : "bg-gray-100 text-gray-600"
                        }`}
                      >
                        {story.isPublished ? "Published" : "Draft"}
                      </button>
                    </td>

                    <td className="px-6 py-4 text-right">
                      <button
                        onClick={() => {
                          setEditingStory(story);
                          setBlocks(convertStoryToBlocks(story));
                          setIsAdding(false);
                        }}
                        className="mr-2 text-gray-500 hover:text-[#6a4bc3]"
                      >
                        <i className="ri-edit-line" />
                      </button>
                      <button
                        onClick={() => handleDelete(story._id)}
                        className="text-gray-500 hover:text-red-500"
                      >
                        <i className="ri-delete-bin-line" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* FORM */}
      {editingStory && (
  <div className="bg-white rounded-xl p-6 border space-y-4">

    <input
      className="input"
      placeholder="Title"
      value={editingStory.title}
      onChange={(e) =>
        setEditingStory({ ...editingStory, title: e.target.value })
      }
    />

    <input
      className="input"
      placeholder="Category"
      value={editingStory.category}
      onChange={(e) =>
        setEditingStory({ ...editingStory, category: e.target.value })
      }
    />

    <textarea
      rows={2}
      className="input"
      placeholder="Excerpt"
      value={editingStory.excerpt}
      onChange={(e) =>
        setEditingStory({ ...editingStory, excerpt: e.target.value })
      }
    />

    {/* CONTENT BUILDER */}
    <div className="space-y-4 border rounded-lg p-4 bg-gray-50">
      <div className="flex gap-2">
        <button onClick={addParagraph} className="px-3 py-1 bg-gray-200 rounded">
          + Paragraph
        </button>

        <label className="px-3 py-1 bg-gray-200 rounded cursor-pointer">
          + Image
          <input
            type="file"
            hidden
            accept="image/*"
            onChange={(e) => addImage(e.target.files[0])}
          />
        </label>
      </div>

      {blocks.map((block, index) => (
        <div key={block.id} className="bg-white border rounded-lg p-3 space-y-2">

          <div className="flex justify-between text-xs text-gray-500">
            <span>{block.type.toUpperCase()}</span>
            <div className="flex gap-2">
              <button onClick={() => moveBlock(index, -1)}>↑</button>
              <button onClick={() => moveBlock(index, 1)}>↓</button>
              <button onClick={() => removeBlock(block.id)} className="text-red-500">Delete</button>
            </div>
          </div>

          {block.type === "paragraph" && (
            <textarea
              rows={4}
              className="input"
              placeholder="Write paragraph..."
              value={block.text}
              onChange={(e) => updateBlockText(block.id, e.target.value)}
            />
          )}

          {block.type === "image" && (
            <img
              src={block.preview}
              className="w-full max-h-80 object-cover rounded-lg"
              alt=""
            />
          )}

        </div>
      ))}
    </div>

    <div className="flex gap-3 pt-4">
      <button
        onClick={handleSave}
        className="bg-[#6a4bc3] text-white px-6 py-2 rounded-lg"
      >
        {isAdding ? "Add Story" : "Save Changes"}
      </button>

      <button
        onClick={() => {
          setEditingStory(null);
          setBlocks([]);
          setIsAdding(false);
        }}
        className="border px-6 py-2 rounded-lg"
      >
        Cancel
      </button>
    </div>
  </div>
)}

    </div>
  );
}
